<template>
  <!-- 導航欄容器 -->
  <div class="navbar-container d-flex content align-items-center">
    <!-- 重置郵箱組件 -->
    <reset-email key_id="navbar" :reset-data="resetData" />
    
    <!-- 聲明模態框組件 -->
    <statement-modal
      :newAnnouncementData="newAnnouncementData"
      :bit="agree_to_terms"
      :is_preview="userData.user_type_id == 1 ? true : false"
    />
    <!-- 用戶日誌模態框 -->
    <b-modal
      id="modal-user-logs"
      title="個人記錄"
      ok-title="確認"
      ok-only 
      ok-variant="primary"
      no-close-on-ok
      size="lg"
    >
      <user-logs-list :user_id="userData.id" />  
    </b-modal>

    <!-- 頭像編輯模態框 -->
    <b-modal
      id="modal-avatar"
      title="修改頭像"
      cancel-title="取消"
      ok-title="確認"
      ok-variant="primary"
      @ok="handleAvater"
      @hide="handleAvaterHide"
      no-close-on-ok
    >
      <b-row>
        <b-col
          class="avatar-col"
          cols="4"
          v-for="(avatar, index) in avatarData"
          :key="index"
        >
            <font-awesome-icon
              class="original-check-icon"
              :icon="['fas', 'circle-check']"
              v-if="avatar.original_is_selected"
            />
            <font-awesome-icon
              class="check-icon"
              :icon="['fas', 'circle-check']"
              v-if="avatar.is_selected"
            />
          <div class="avatar-container" @click="selectAvatar(avatar.id)">
            <b-img class="img-fluid" :src="avatar.image_url"  />
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Nav Menu Toggler：< 1200px 顯示漢堡 icon，>= 1200px 顯示 switch 展開/收起 -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <ul class="nav navbar-nav align-items-center d-none d-xl-flex nav-menu-switch-wrap">
      <li class="nav-item">
        <b-form-checkbox
          :checked="isMenuOpen"
          name="left_menu_visible"
          switch
          inline
          class="mb-0 nav-menu-switch"
          @input="onMenuSwitchChange"
        >
          {{ isMenuOpen ? "展開" : "收起" }}
        </b-form-checkbox>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- <dark-Toggler class="d-none d-lg-block mr-1" /> -->

      <a class="mx-2 nav-icon" href="javascript:void(0)" @click="goBack()">
        <font-awesome-icon
          style="font-size: 18px"
          title="返回"
          icon="fa-solid fa-arrow-left"
        />
      </a>
      <a class="mr-2 nav-icon" href="javascript:void(0)" @click="refresh()">
        <font-awesome-icon
          style="font-size: 18px"
          title="刷新"
          icon="fa-solid fa-arrows-rotate"
        />
      </a>
      <a
        class="mr-2 nav-icon"
        target="_blank"
        v-for="(redirect, index) in redirectUrlData.contents"
        :key="redirect.url + index"
        :href="redirect.url"
      >
        <font-awesome-icon
          style="font-size: 18px"
          :title="redirect.title"
          :icon="`fa-solid ${redirect.icon}`"
        />
      </a>
      <!-- <a
        class="mr-2 nav-icon"
        target="_blank"
        href="https://wingfatdesign.com/"
      >
        <font-awesome-icon
          style="font-size: 18px"
          :icon="['fas', 'diamond-turn-right']"
        />
      </a> -->

      <!-- 客戶需知 -->
      <b-link
        v-if="ability.can('read', 'navbar_announcement')"
        class="mr-2 nav-icon"
        href="javascript:void(0)"
        @click="$bvModal.show(userData.user_type_id == 1 ? 'statement-modal-preview' : 'statement-modal')"
      >
        <font-awesome-icon
          style="font-size: 18px"
          title="客戶需知"
          icon="fa-solid fa-file-alt"
        />
      </b-link>
    </div>

    <div class="d-flex align-items-center" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
      <div class="custom-dropdown mr-1 mt-25">
        <div class="dropdown-trigger d-flex align-items-center" >
          <div class="d-flex user-nav">
            <b-link class="" href="javascript:void(0)">
              <font-awesome-icon
                style="font-size: 18px"
                title="設定"
                icon="fa-solid fa-gear"
              />
            </b-link>
          </div>
        </div>

        <div class="dropdown-menu" :class="{ 'show': showDropdown }" >
          <div class="dropdown-item d-flex align-items-center" @click="triggerResetEmailModal">
            <feather-icon size="16" icon="EditIcon" class="mr-50" />
            <span>修改電郵</span>
          </div>

          <div class="dropdown-divider"></div>

          <div class="dropdown-item d-flex align-items-center" @click="handleEditPassword">
            <feather-icon size="16" icon="EditIcon" class="mr-50" />
            <span>修改密碼</span>
          </div>

          <div class="dropdown-divider"></div>

          <div class="dropdown-item d-flex align-items-center" @click="$bvModal.show('modal-user-logs')">
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>個人記錄</span>
          </div>  
          
          <div class="dropdown-divider"></div>

          <b-link
            v-if="ability.can('read', 'user_prepayments')"
            class="dropdown-item d-flex align-items-center"
            :to="{ name: 'worker-advance-payment-list' }"
          >
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>用戶預支記錄</span>
          </b-link>

          <div v-if="ability.can('read', 'user_prepayments')" class="dropdown-divider"></div>

          <b-link
            v-if="ability.can('read', 'user_claims')"
            class="dropdown-item d-flex align-items-center"
            :to="{ name: 'worker-claim-list' }"
          >
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>用戶報銷記錄</span>
          </b-link>

          <div v-if="ability.can('read', 'user_claims')" class="dropdown-divider"></div>

          <b-link
            v-if="ability.can('read', 'user_salaries')"
            class="dropdown-item d-flex align-items-center"
            :to="{ name: 'worker-salary-list' }"
          >
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>用戶工資記錄</span>
          </b-link>

          <div class="dropdown-divider"></div>

          <div class="dropdown-item d-flex align-items-center" @click="handleLogout">
            <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
            <span>登出</span>
          </div>
        </div>
      </div>
      <a
          class="mr-1 mt-25 cursor-pointer"
          href="javascript:void(0)"
          @click="handleLogout"
        >
          <font-awesome-icon
            style="font-size: 18px"
            title="登出"
            icon="fa-solid fa-right-from-bracket"
          />
        </a>
        <b-link v-if="ability.can('read', 'messages')"
          class="mr-1 mt-25"
          :to="{ name: 'messages-list' }"
        >
          <font-awesome-icon
            style="font-size: 18px"
            title="消息"
            icon="fa-solid fa-bell"
          />
        </b-link>

      <b-link class="d-flex align-items-center" href="javascript:void(0)" @click="$bvModal.show('modal-avatar')">
        <p class="user-name font-weight-bolder mr-50 mb-0" v-html="userName"></p>
        <!-- <span class="user-status" v-html="storeName"></span> -->
        <b-avatar
          size="40"
          variant="light-primary"
          badge
          :src="userAvatar"
          class="badge-minimal"
          badge-variant="success"
        />
        
      </b-link>
    </div>
    <edit-password :force="mustChangePassword" @success="onForcedPasswordChanged" />
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BFormInput,
  BDropdownDivider,
  BAvatar,
  BModal,
  BRow,
  BCol,
  BImg,
  BFormCheckbox,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import { getUserData, getHomeRouteForLoggedInUser } from "@/auth/utils";
import useJwt from "@/auth/jwt/useJwt";
import axiosIns from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import EditPassword from "./EditPassword.vue";
import statementModal from "@/views/dashboard/modal/modal-statement.vue";
import ability from "@/libs/acl/ability";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import ResetEmail from "@/layouts/components/resetEmail.vue";
import userLogsList from "@/views/user/user-logs/user-logs-list/userLogsList.vue";
import store from "@/store";
import { EventBus } from "@/main";

export default {
  // 組件數據
  data() {
    return {
      ability, // 權限控制對象
      userData: {}, // 用戶數據
      userName: getUserData().name_cn, // 用戶名稱
      // storeName: "",
      agree_to_terms: false, // 是否同意條款
      mustChangePassword: false, // 是否需強制修改密碼
      resetData: { id: 0, email: "", vertification_code: "" }, // 重置郵箱數據
      redirectUrlData: {}, // 重定向URL數據
      newAnnouncementData: null, // 新公告數據
      avatarData: [], // 頭像數據
      isConfirming: false, // 是否正在確認
      showDropdown: false, // 是否顯示下拉菜單
    };
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormInput,
    BFormCheckbox,
    BAvatar,
    BModal,
    BRow,
    BCol,
    BImg,
    statementModal,
    // Navbar Components
    DarkToggler,
    ResetEmail,
    EditPassword,
    userLogsList,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
    isVerticalMenuActive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isXl() {
      try {
        return this.$store.getters['app/currentBreakPoint'] === 'xl';
      } catch (e) {
        return false;
      }
    },
    isMenuOpen() {
      try {
        if (this.isXl && this.$store.state.verticalMenu) {
          return !this.$store.state.verticalMenu.isVerticalMenuCollapsed;
        }
        return this.isVerticalMenuActive !== false;
      } catch (e) {
        return true;
      }
    },
    userAvatar() {
      return this.userData.user_image ? this.userData.user_image.image_url : require("@/assets/images/avatars/default-user.png");
    },
  },
  methods: {
    /** 左側選單 switch：傳入 true=展開、false=收起，並同步 store */
    onMenuSwitchChange(expanded) {
      try {
        if (this.isXl && this.$store.state.verticalMenu) {
          this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', !expanded);
        } else {
          if (this.isVerticalMenuActive !== expanded) this.toggleVerticalMenuActive();
        }
      } catch (e) {
        if (typeof this.toggleVerticalMenuActive === 'function') this.toggleVerticalMenuActive();
      }
    },
    // 重置頭像數據
    resetAvatarData() {
      this.avatarData.forEach((avatar) => {
        avatar.is_selected = false;
        if (avatar.original_is_selected) {
          avatar.is_selected = true;
        }
      });
    },

    // 選擇頭像
    selectAvatar(id) {
      this.avatarData.forEach((avatar) => {
        avatar.is_selected = avatar.id === id;
      });
    },

    // 處理頭像模態框隱藏
    handleAvaterHide(e) {
      if (!this.isConfirming) {
        this.resetAvatarData();
      }
      this.isConfirming = false;
    },

    // 處理頭像更新
    handleAvater(e) {
      e.preventDefault();
      this.isConfirming = true;
      var user_image_id = this.avatarData.find(avatar => avatar.is_selected)?.id;
      
      // 顯示確認對話框
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          // 發送更新請求
          store
            .dispatch("app/editUserAvatar", {user_image_id})
            .then((response) => {
              // 成功提示
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
              });
              this.$bvModal.hide("modal-avatar");
              this.fetchUserInfo();
            })
            .catch((error) => {
              // 錯誤提示
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    },
    handleEditPassword() {
      this.$root.$emit("bv::show::modal", "modal-edit-password", "#btnShow");
    },
    triggerResetEmailModal() {
      this.resetData = {
        id: getUserData().id,
        email: "",
        vertification_code: "",
      };
      this.$bvModal.show("modal-reset-email-navbar");
    },
    handleLogout() {
      //Request server to void the token
      axiosIns.get("/api/auth/logout");
      localStorage.clear();
      //Reqired to login page
      //Show the success message
      this.$router.replace("/login").then(() => {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Success`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `You have successfully logged out!`,
          },
        });
      });
    },
    fetchUserInfo() {
      store.dispatch("app/fetchUserInfo").then((response) => {
        this.userData = response.data.userData;
        if (this.userData.user_type_id == 2) {
          // 先檢查是否需要強制修改密碼（後端以 '0'/'1' 字串回傳）
          this.mustChangePassword = String(this.userData.must_change_password || '0') === '1';
          if (this.mustChangePassword) {
            this.$bvModal.show("modal-edit-password");
            return; // 先完成強制改密碼，再進一步檢查首次登入聲明
          }
          // 若不需強制改密碼，才檢查是否同意條款（首次登入聲明）
          this.agree_to_terms = !!this.userData.agree_to_terms;
          if (!this.agree_to_terms) {
            this.$bvModal.show("statement-modal");
          }
        }
        this.fetchAvatar();
      });
    },
    fetchSettingInfo() {
      store.dispatch("app/fetchSettingInfo", 1).then((response) => {
        this.newAnnouncementData = JSON.parse(response.data.setting.value);
      });

      store.dispatch("app/fetchSettingInfo", 2).then((response) => {
        this.redirectUrlData = response.data.setting;
        this.redirectUrlData.contents = JSON.parse(response.data.setting.value);
      });
    },
    fetchAvatar() {
      store.dispatch("app/fetchAvatars").then((response) => {
        this.avatarData = response.data.user_images.map(user_image => {
          return {
            id: user_image.id,
            image_url: user_image.image_url,
            is_selected: this.userData.user_image ? user_image.id === this.userData.user_image.id : false,
            original_is_selected: this.userData.user_image ? user_image.id === this.userData.user_image.id : false,
          }
        });
      });
    },
    onForcedPasswordChanged() {
      // 密碼修改成功後重新拉取用戶資料，關閉強制狀態並再檢查首次登入聲明
      this.mustChangePassword = false;
      this.fetchUserInfo();
    },
    refresh() {
      window.location.reload();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    // 註冊事件監聽器
    EventBus.$on("redirectUrlSaved", this.fetchUserInfo);
    EventBus.$on("reload-user-avatar", this.fetchUserInfo);
    
    // 初始化數據
    this.fetchUserInfo();
    this.fetchSettingInfo();

    // 檢查用戶是否已登錄
    if (!getUserData()) {
      this.$router.replace("/login").then(() => {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Success`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `You have successfully logged out!`,
          },
        });
      });
    } 
  },
  beforeDestroy() {
    // 組件銷毀前移除事件監聽器
    EventBus.$off("redirectUrlSaved", this.fetchSettingInfo);
    EventBus.$off("reload-user-avatar", this.fetchUserInfo);
  },
};
</script>

<style lang="scss">
.avatar-col {
  margin-bottom: 10px;
  .check-icon, .original-check-icon{
    position: absolute;
    z-index: 5;
    right: 15px;
    top: 5px;
  }
  .original-check-icon{
    color: #dedede;
  }
  .check-icon{
    color: #aaafff;
    z-index: 6;
  }
}
.avatar-container {
  position: relative;
  border: 5px solid #2381c0;
  border-radius: 50%;
  /* padding: 5px; */
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1/1;
  position: relative;
  display: grid;
  place-items: center;
}

.custom-dropdown {
  position: relative;
  
  .dropdown-trigger {
    cursor: pointer;
    padding: 5px;  /* 增加可點擊區域 */
  }
  
  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    z-index: 9999;  /* 提高 z-index */
    min-width: 180px;
    margin-top: 5px;  /* 增加與觸發器的間距 */
    opacity: 0;  /* 初始設置為透明 */
    visibility: hidden;  /* 初始設置為隱藏 */
    transition: all 0.2s ease;  /* 添加過渡效果 */
    
    &.show {
      opacity: 1;
      visibility: visible;
    }
  }

  .dropdown-item {
    padding: 0.5rem 1rem;
    cursor: pointer;
    white-space: nowrap;  /* 防止文字換行 */

    &:hover {
      background-color: #f8f9fa;
    }
  }

  .dropdown-divider {
    border-top: 1px solid #ddd;
    margin: 0.5rem 0;
  }
}

.nav-menu-switch-wrap {
  .nav-menu-switch {
    margin-top: 2px;
  }
  .custom-control-label {
    padding-left: 0.5rem;
  }
}

</style>

